'use client';
import { useEffect, useState } from 'react';

import {
	type DialogSolutionResult,
	getDialogSolutionAction,
} from '@/features/ai-dialog';

import type { ControlsTrack } from '../lib/controls-analytics';
export function useDialogSolution(
	problemId: string,
	languageId: number | undefined,
	track: ControlsTrack,
) {
	const [attempt, setAttempt] = useState(0);
	const [state, setState] = useState<{
		key: string;
		result: DialogSolutionResult;
	} | null>(null);
	const key = `${problemId}:${languageId}:${attempt}`;
	useEffect(() => {
		if (languageId === undefined) return;
		let active = true;
		void getDialogSolutionAction(problemId, languageId)
			.catch((): DialogSolutionResult => ({ status: 'error' }))
			.then((result) => {
				if (!active) return;
				setState({ key, result });
				track('solution', {
					action: 'load',
					stage: result.status === 'ready' ? 'success' : 'error',
					...(result.status === 'ready'
						? {}
						: {
								reason: result.status === 'error' ? 'request' : 'unavailable',
							}),
				});
			});
		return () => {
			active = false;
		};
	}, [problemId, languageId, key, track]);
	return {
		result: state?.key === key ? state.result : null,
		retry: () => {
			track('solution', { action: 'retry', stage: 'intent' });
			setAttempt((value) => value + 1);
		},
	};
}
